'use client';

import { FileCheck, FlaskConical, Lightbulb, ListChecks, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ACTION_DEFS = [
  { key: 'startGrading', Icon: FileCheck },
  { key: 'howItWorks', Icon: Lightbulb },
  { key: 'sampleData', Icon: FlaskConical },
  { key: 'taskTypes', Icon: ListChecks },
  { key: 'privacy', Icon: ShieldCheck },
] as const;

interface TeacherDashboardWidgetsProps {
  onSubmit: (text: string, opts?: { attachedFileNames?: string[] | null }) => void;
}

export function TeacherDashboardWidgets({ onSubmit }: TeacherDashboardWidgetsProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-3xl flex flex-wrap justify-center gap-3 px-2 sm:px-0">
      {ACTION_DEFS.map(({ key, Icon }) => (
        <button
          key={key}
          onClick={() => onSubmit(t(`Dashboard.actions.${key}.prompt`), { attachedFileNames: null })}
          className="flex items-center gap-2 rounded-full border border-border bg-card px-5 py-2 text-base text-foreground transition-colors hover:bg-accent hover:text-accent-foreground shadow-sm"
          type="button"
        >
          <Icon className="w-4 h-4 text-muted-foreground" />
          {t(`Dashboard.actions.${key}.label`)}
        </button>
      ))}
    </div>
  );
}
